export default __webpack_public_path__ + "assets/1ef24c4391853611e49087473344122c.png";